import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const PlayIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>((props, forwardedRef) => {
  return (
    <IconWrapper {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M5.8521 19.9415L20.6607 12.7655C20.7801 12.707 20.8778 12.6151 20.9402 12.4925C21.0813 12.1944 20.9646 11.8351 20.6743 11.6846L5.86295 4.06572C5.46947 3.86236 5 4.15486 5 4.60336V19.3927C5 19.4846 5.02171 19.5738 5.0597 19.6546C5.20081 19.9582 5.55631 20.0836 5.8521 19.9415Z"
          fill="#222"
        />
      </svg>
    </IconWrapper>
  )
})
